<template>
<div class="wrapper-content wrapper">
  <div class="ibox float-e-margins">
    <div class="ibox-title">
      <h5>Index Checker</h5>
      <div class="ibox-tools">
        <input type="text" name="domain" id="" placeholder="Domain" class="pretty-input" v-model="addDomain">
        <select name="country" class="pretty-input m-l-sm" v-model="addCountry">
          <option value="us">https://www.google.com</option>
          <option value="uk">https://www.google.co.uk</option>
          <option value="ca">https://google.ca</option>
          <option value="de">https://google.de</option>
          <option value="fr">https://google.fr</option>
          <option value="es">https://google.es</option>
          <option value="br">https://google.com.br</option>
          <option value="mx">https://google.com.mx</option>
          <option value="in">https://google.co.in</option>
          <option value="jp">https://google.co.jp</option>
          <option value="cn">https://google.cn</option>
          <option value="au">https://google.com.au</option>
        </select>
        <button class="btn btn-primary btn-xs m-l-sm" @click="addIndexCheck">Add Check</button>
      </div>
    </div>
    <div class="ibox-content table-responsive col-lg-12">
      <table class="table table-striped table-bordered table-hover dataTables-example">
        <thead>
        <tr>
          <th>Domain</th>
          <th class="col-lg-1">Country</th>
          <th>Started</th>
          <th>Completed</th>
          <th class="col-lg-1">Pages Found</th>
          <th class="col-lg-1">
            Actions
            <i class="fa fa-refresh pull-right pointer" @click="getIndexChecks"></i>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="check in checks" :key="check.id">
          <td>
            <i class="fa fa-play blue" title="Running" v-if="check.status === 'started'" />
            <i class="fa fa-clock orange" title="Added" v-if="check.status === 'added'" />
            <i class="fa fa-check green" title="Completed" v-if="check.status === 'completed'" />
            {{ check.payload.url }}
          </td>
          <td>{{ check.payload.country }}</td>
          <td>{{ $moment(check.startTime.date).format('DD.MM.Y HH:mm') }}</td>
          <td>
            <span v-if="check.status === 'completed'">
            {{ check.endTime ? $moment(check.endTime.date).format('DD.MM.Y HH:mm') : '/'}}
            </span>
            <span v-else>
              Queued: {{ check.pendingActions || 0 }}
            </span>
          </td>
          <td class="center">/</td>
          <td>
            <a
              :href="'https://toolbox.aphex.me/toolbox/seo/index-checker/index-check/' + check.id + '/results?format=csv'"
               v-if="check.status === 'completed'"><i class="fa fa-download"/></a>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th>Domain</th>
          <th>Country</th>
          <th>Started</th>
          <th>Completed</th>
          <th>Pages Found</th>
          <th>Actions</th>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'IndexChecker',
  data () {
    return {
      checks: [],
      addDomain: '',
      addCountry: 'us'
    }
  },
  mounted () {
    this.getIndexChecks()
  },
  methods: {
    getIndexChecks () {
      axios.get('/std/index-checker/index-checks')
        .then(r => {
          this.checks = r.data.data
        })
        .catch()
    },
    addIndexCheck () {
      axios.post('/std/index-checker/index-check', {
        domain: this.addDomain,
        country: this.addCountry
      })
        .then(r => {
          this.addDomain = ''
          this.getIndexChecks()
          this.$toastr.success('Good stuff', 'Ya man!')
        })
        .catch(e => {
          this.$toastr.error(e, 'Ouch')
        })
    },
    runIndexCheck (id) {
      axios.post('/std/index-checker/run/' + id)
        .then(r => {
          this.getIndexChecks()
          this.$toastr.success('Started!', 'C\'mon!')
        })
        .catch(e => {
          this.$toastr.error(e, 'Omfg...')
        })
    },
    downloadCsv (id) {
      // @todo Do this file upload so we can put the bloody user auth on it
      axios.get('/toolbox/seo/index-checker/index-check/' + id + '/results?format=csv')
        .then(r => {
          let response = r.data
          console.log(response)
        })
        .catch()
      // Dl it and shit
    }
  }
}
</script>
<style>
  .center {
    text-align: center;
  }
  .green {
    color: green;
  }
  .blue {
    color: #0c73b8;
  }
  .orange {
    color: orange;
  }
  .pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/Std/IndexChecker.vue